import axios from "@/axios";
import Util from '../../util/util';

export const namespaced = true;

export const state = {
  usOffices: [],
  pnOffices: [],
};

export const getters = {
  usOffices: (state) => {
    return state.usOffices;
  },
  pnOffices: (state) => {
    return state.pnOffices;
  },
};

export const mutations = {
    SET_US_OFFICES(state, response) {
        let usOffices = response.data;

        if (!Util.isNullOrEmpty(usOffices)) {
            usOffices.sort(Util.sortAscByName);
        }

        state.usOffices = usOffices;
    },
    SET_PN_OFFICES(state, response) {
        let pnOffices = response.data;

        if (!Util.isNullOrEmpty(pnOffices)) {
            pnOffices.sort(Util.sortAscByName);
        }

        state.pnOffices = pnOffices;
    },
};

export const actions = {
  async getUsFinanceOffices({ commit }) {
    commit("SET_US_OFFICES", await axios.get("/api/financialoffices/countrycode/us"));
  },
  async getPnFinanceOffices({ commit }, pnCountryId) {
    // Fetch Only if Partner's Country Id is set.
    if (pnCountryId) {
      commit("SET_PN_OFFICES", await axios.get("/api/financialoffices/countryid/" + pnCountryId));
    }
  },
};
